import React from 'react'
import WhiteArrowPNG from '../../../assets/images/white_arrow.png'
import './collectionHeader.scss'

const CollectionHeaderSection = () => {

    return (
        <div className="collectionHeader">
            <h1 className="collection_name">Hashreels E1: Alien in Marigolds</h1>
            <img src={WhiteArrowPNG}/>
        </div>
    )
}

export default CollectionHeaderSection
